<template>
  <ul class="main-nav__nav list-inline">
    <template v-for="(link, index) in navLinks">
      <li v-if="link.external" :key="link.name">
        <a
          :href="link.url"
          target="_blank"
          rel="nofollow me noopener noreferrer"
        >
          {{ link.name }}

          <i v-if="link.external" class="iconmoon-link"></i>
        </a>
      </li>
      <li tabindex="0" v-else-if="link.children" :key="link.name">
        <a
          href="javascript:void(0)"
          class="sub-nav"
          @click="toggleSubNav(`collapse${index}`)"
        >
          Support <i v-html="AngleDown"></i>
        </a>
        <MainNavSubList :ref="`collapse${index}`" :links="link.children" />
      </li>
      <li v-else :key="link.name">
        <router-link
          :to="link.url"
          :exact="link.exact"
          :class="{ 'main-nav__buy': link.button }"
        >
          {{ link.name }}
        </router-link>
      </li>
    </template>
  </ul>
</template>

<script>
import MainNavSubList from "./MainNavSubList";
import Collapse from "../common/Collapse";
import AngleDown from "../../assets/icons/angle-down.svg";

export default {
  props: {
    navLinks: Array,
  },
  components: {
    MainNavSubList,
    Collapse,
  },
  data() {
    return {
      AngleDown,
    };
  },
  methods: {
    toggleSubNav(ref) {
      if (window.innerWidth <= 991) {
        this.$refs[ref][0].toggle();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.main-nav__nav {
  display: inline-block;
  @include list-inline;

  .wishlist {
    a {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-top: 30px;
      color: #d2efa9;
      // font-weight: bold;
      background-color: #75b022;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
      // background-color: #75b022;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
      // background-color: -webkit-linear-gradient(top, #6fa720 5%, #588a1b 95%);
      // background-color: linear-gradient(to bottom, #6fa720 5%, #588a1b 95%);
      // background-color: linear-gradient(to right, #6fa720 5%, #588a1b 95%);
      background-image: linear-gradient(
        to right,
        rgb(111, 167, 32) 5%,
        rgb(88, 138, 27) 95%
      );
      border-radius: 2px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
      background-size: contain;
      width: max-content;
      padding: 10px 20px;
      text-transform: unset;
      font-size: 22px;
      &:hover,
      &:focus {
        color: #fff;
        background-image: #6aa621;
        background-image: -webkit-linear-gradient(top, #8ed629 5%, #6aa621 95%);
        background-image: linear-gradient(to bottom, #8ed629 5%, #6aa621 95%);
        background-image: linear-gradient(to right, #8ed629 5%, #6aa621 95%);
        // background-color: lighten(#75b022, 2%);
      }
      &::after {
        display: none;
        transition: none;
        transform: none;
        transform-origin: left center;
      }
      @media (max-width: 1200px) {
        font-size: 15px;
      }
      @media (min-width: 990px) {
        display: none;
      }
    }
  }
  li {
    position: relative;
    padding: 0 14px;
    line-height: $navSize;
    text-transform: uppercase;
    font-family: $metron;
    font-size: 15px;

    @media (max-width: $screen-xl) {
      line-height: $navSizeSm;
    }

    @media (max-width: $screen-sm-max) {
      padding: 0 7px;
      font-size: 13px;
    }

    &:hover,
    &:focus {
      .main-nav__sub-nav {
        @media (min-width: $screen-md) {
          visibility: visible;
          transform: scaleY(1);
        }
      }
    }
  }

  a {
    color: #fff;
    text-decoration: none;
    position: relative;
    top: -3px;

    &::after {
      content: "";
      position: absolute;
      bottom: -6px;
      right: 0;
      display: block;
      width: 100%;
      height: 2px;
      background-color: #c80813;
      transition: all 0.3s ease;
      transform: scaleX(0);
      transform-origin: left center;
    }

    &:hover,
    &:focus,
    &.router-link-active {
      text-decoration: none;

      &::after {
        transform: scaleX(1);
      }
    }

    &.sub-nav {
      &::after {
        display: none;
      }
    }

    @media (max-width: $screen-xl) {
      top: 0;
    }

    i {
      font-size: 0.75em;
      font-weight: bold;
      margin-left: 0.5em;
    }
  }

  a.main-nav__buy {
    background-color: #c80004;
    padding: 8px 26px;
    width: 239px;
    text-align: center;
    font-size: 13px;
    transition: background-color $linkTransition;

    &::after {
      display: none;
    }

    &:hover,
    &:focus {
      background-color: lighten(#c80004, 10%);
    }
  }

  @media (max-width: $screen-sm-max) {
    display: block;

    li {
      display: block;
      margin: 0;
      padding: 0;
      line-height: 1;

      &:not(:last-child) {
        margin-bottom: 25px;
      }
    }

    a {
      font-size: 17px;
      letter-spacing: 0.08em;
      color: #d5d5d5;
    }

    a.main-nav__buy {
      display: inline-block;
      margin-top: 40px;
      padding: 10px 26px;
      font-size: 16px;
      letter-spacing: 0.12em;
    }
  }
}
</style>

<style lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

// .main-nav__nav > li > a i svg {
//   width: 1em;
//   height: 1em;
//   fill: currentColor;
//   /*icon to thin, we have to manually make it bold*/
//   stroke: currentColor;
//   stroke-width: 2px;
// }
</style>
